import moment from 'moment-timezone';
export var convertToBlocksCalendar = function (dtos, timeZone, masterData) { return dtos.map(function (dto) { return convertToBlockCalendar(dto, timeZone, masterData); }); };
export var convertToBlockCalendar = function (dto, timeZone, masterData) { return ({
    id: dto.id,
    uuid: dto.uuid,
    calendarId: dto.calendar_id,
    staff: convertToStaff(dto),
    start: moment.tz(dto.start, timeZone),
    end: moment.tz(dto.end, timeZone),
    title: dto.title,
    description: dto.description,
    recurringUuid: dto.recurring_uuid,
    frequency: masterData.blockFrequencies.find(function (f) { return f.id === dto.schedule_frequency_id; })
}); };
var convertToStaff = function (dto) { return ({
    id: dto.staff_id,
    firstName: dto.staff_first_name,
    lastName: dto.staff_last_name,
    image: dto.staff_image
}); };
export var convertToRecurrent = function (dto, masterData) { return ({
    frequency: masterData.blockFrequencies.find(function (frequency) { return frequency.id === dto.schedule_frequency_id; }),
    remaining: dto.remaining,
    total: dto.total
}); };
export var convertToAlerts = function (dtos) { return dtos.map(function (dto) { return convertToAlert(dto); }); };
var convertToAlert = function (dto) { var _a; return ({ alertType: dto.alert_type, message: dto.message, error: (_a = dto.error) !== null && _a !== void 0 ? _a : false }); };
